import * as yup from "yup";

export const addressTypeSchema = yup.object().shape({
  name: yup.string().required().label("Name"),
});
